import wcbtToggleCompareProduct from './compare-product/toggle-compare';
import wcbtToggleWishList from './wishlist/toggle-wishlist';
import wcbtToggleQuickView from './quick-view/toggle-quick-view';
import wcbtMaxSalePopup from './maxsale/popup';
import wcbtSaleNoticePopup from './sale-notice/popup';
import wcbtVariation from './variation/variation';
import wcbtElementorHook from './elementor/el-hook';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	wcbtToggleCompareProduct();
	wcbtToggleWishList();
	wcbtToggleQuickView();
	wcbtMaxSalePopup();
	wcbtSaleNoticePopup();
	wcbtVariation();
	wcbtElementorHook();
} );
